import { FC } from 'react';
import './ModalChatMessageView.scss';
import ModalDefault from '../../../ModalDefault/ModalDefault';
import { Col, Container, Row } from 'react-bootstrap';
import ChatMessage from '../../ChatMessage/ChatMessage';
import { ChatMessageModel } from '../../../../models/Chat/ChatMessageModel';

interface ModalChatMessageViewProps {
  show: boolean;
  onClose: () => void;
  message: ChatMessageModel;
}

const ModalChatMessageView: FC<ModalChatMessageViewProps> = ({ show, onClose, message }) => {
  const handleClose = () => {
    onClose();
  }

  return (
    <ModalDefault
      title={`Visualizar Mensagem`}
      show={show}
      onClose={handleClose}
      sizeModal={"xl"}
      showFooter={true}
      backdrop="static"
      backgroundColor="#fff"
      classNameBody="p-0"
    >
      <div className="ModalChatMessageView" data-testid="ModalChatMessageView">
        <div
          className="chats-wrapper"
          style={{
            background: `url(${process.env.PUBLIC_URL}/assets/img/background-wrapper.png)`,
            backgroundPosition: 'top center',
            backgroundRepeat: 'repeat',
            padding: '25px 40px'
          }}
        >
          <div className="chat-messages-container">
            <Container>
              <Row className="justify-content-center">
                <Col md={12}>
                  <ChatMessage message={message} key={0} />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </ModalDefault>
  );
}

export default ModalChatMessageView;
